import { MasterArtworkCollectionState } from "../collections/data.type";
import {
  MasterArtworkPrintingTechniqueActionType,
  MasterArtworkPrintingTechniqueActionTypes, MasterArtworkPrintingTechniqueState, Option,
} from "./data.type";
import { MasterArtworkNameState } from "../artwork-name/data.type";
import {
  IColor,
  IDecorationTech,
  IMold,
  IRequestStatusReason,
} from "../../../types/data.interface";
import {
  MasterArtworkNumberActionType,
  MasterArtworkNumberActionTypes,
  MasterArtworkNumberState,
} from "../artwork-number/data.type";

const setCollection = (
  collection: MasterArtworkCollectionState | null,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_COLLECTION,
  payload: { collection },
});

const setId = (id: string): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_ID,
  payload: { id },
});

const setName = (name: string): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_NAME,
  payload: { name },
});

const setDecorationTechnique = (
  decoration_technique: IDecorationTech,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_DECORATION_TECHNIQUE,
  payload: { decoration_technique },
});

const setColor = (color: IColor): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_COLOR,
  payload: { color },
});

const setTechnicalFileUrl = (
  technical_file_url: string,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_TECHNICAL_FILE_URL,
  payload: { technical_file_url },
});

const setCommentsAndTechnicalFileRequests = (
  comments_and_technical_file_requests: string,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_COMMENTS_AND_TECHNICAL_FILE_REQUESTS,
  payload: { comments_and_technical_file_requests },
});

// const setCode = (code: string): MasterArtworkPrintingTechniqueActionType => ({
//   type: MasterArtworkPrintingTechniqueActionTypes.SET_CODE,
//   payload: { code },
// });

const setImageUrl = (
  image_url: string,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_IMAGE_URL,
  payload: { image_url },
});

const setRegion = (
  region: string,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_REGION,
  payload: { region },
});

const setArtworkName = (
  artwork_name: MasterArtworkNameState | null,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_ARTWORK_NAME,
  payload: { artwork_name },
});

const setArtworkNumber = (
  artwork_number: MasterArtworkNumberState | null,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_ARTWORK_NUMBER,
  payload: { artwork_number },
});

const setMolds = (
  molds: IMold[] | null,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_MOLDS,
  payload: { molds },
});

const setSubmitComment = (
  comment: string,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_SUBMIT_COMMENT,
  payload: { submitComment: comment },
});

const setApproveComment = (
  comment: string,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_APPROVE_COMMENT,
  payload: { approveComment: comment },
});

const setRejectComment = (
  comment: string,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_REJECT_COMMENT,
  payload: { rejectComment: comment },
});

const setRejectReason = (
  reason: IRequestStatusReason,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_REJECT_REASON,
  payload: { rejectReason: reason },
});

const setIsValid = (
  isValid: boolean | null,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_IS_VALID,
  payload: { isValid },
});

const setIsReadOnly = (
  isReadOnly: boolean ,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_IS_READ_ONLY,
  payload: { isReadOnly },
});

const setRequestStatus = (
  requestStatus: string | null,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_REQUEST_STATUS,
  payload: { requestStatus },
});

const setPrintingTechnique = (
  artworkName: MasterArtworkPrintingTechniqueState,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_PRINTING_TECHNIQUE,
  payload: { ...artworkName },
});

const resetState = (): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.RESET_STATE,
  payload: {},
});

const setUnsavedChanges = (
  hasUnsavedChanges: boolean,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_UNSAVED_CHANGES,
  payload: { hasUnsavedChanges },
});

const stPurchasedPartOrSubAssembly = (
  purchasedPartOrSubAssembly: any,
): MasterArtworkPrintingTechniqueActionType => ({
  type: MasterArtworkPrintingTechniqueActionTypes.SET_PURCHASED_PART_OR_SUB_ASSEMBLY,
  payload: { purchasedPartOrSubAssembly },
});

export const MasterArtworkPrintingTechniqueActions = {
  setCollection,
  setId,
  setName,
  setDecorationTechnique,
  setColor,
  setTechnicalFileUrl,
  setCommentsAndTechnicalFileRequests,
  // setCode,
  setImageUrl,
  setRegion,
  setArtworkName,
  setArtworkNumber,
  setMolds,
  setSubmitComment,
  setApproveComment,
  setRejectComment,
  setRejectReason,
  setIsValid,
  setRequestStatus,
  setPrintingTechnique,
  resetState,
  setIsReadOnly, setUnsavedChanges,stPurchasedPartOrSubAssembly
};
